// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"468":"0d43bc81","470":"0d43bc81","549":"737f695b","892":"6ed6d72f"}[chunkId] + ".chunk.css";
};